// extracted by mini-css-extract-plugin
export default {"agencyReviewsControls":"agencyReviewsControls_mEC86","text":"text_KSbml"};